'use strict';

var _GoogleFont = require('./GoogleFont');

var _GoogleFont2 = _interopRequireDefault(_GoogleFont);

var _TypographyStyle = require('./TypographyStyle');

var _TypographyStyle2 = _interopRequireDefault(_TypographyStyle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = {
  GoogleFont: _GoogleFont2.default,
  TypographyStyle: _TypographyStyle2.default
};


//////////////////
// WEBPACK FOOTER
// ../~/react-typography/dist/index.js
// module id = 454
// module chunks = 0